import * as yup from 'yup';
import { login as TEXT } from 'locales/en';

const schema = yup.object().shape({
  email: yup
    .string()
    .email(TEXT.errors.email.invalid)
    .required(TEXT.errors.email.required),
  password: yup
    .string()
    .min(8, TEXT.errors.password.min)
    .required(TEXT.errors.password.required),
});

export default schema;
